
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amobee",
      function () {
        return require("private-next-pages/destinations/amobee.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amobee"])
      });
    }
  